import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {allCards} from '../cards-mockup';

@Component({
  selector: 'app-cards-table',
  templateUrl: './cards-table.component.html',
  styleUrls: ['./cards-table.component.css']
})
export class CardsTableComponent implements OnChanges, OnInit {

  @Input() counter: number;
  @Input() level: number;
  @Input() isReadyForClairvoyant: boolean; // All the cards are touchable.
  @Output() cardsVisibleHelper = new EventEmitter<boolean[][]>();
  @Output() closedCardIdx = new EventEmitter<number[]>(); // Card closed by the application
  @Output() clickedCardIdx = new EventEmitter<number[]>(); // Selected solution by the clairvoyant

  cardsId: number[][] = [];
  cardsVisible: boolean[][] = [];
  cardsClickable: boolean[][] = [];
  solutionIdx = [];
  tableSize: number;
  cards = allCards;

  constructor() {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.level || changes.counter) {
      this.generateRandomExercise();
    }

    if (changes.isReadyForClairvoyant) {
      if (changes.isReadyForClairvoyant.currentValue === true) {
        const randRow = Math.floor((Math.random() * (this.getSizeOfTable() - 1)));
        const randColumn = Math.floor((Math.random() * (this.getSizeOfTable() - 1)));
        this.getAllCardsClickable();
        this.turnCard(randRow, randColumn);
      }
    }
  }

  initAllValues() {
    this.cardsId = [];
    this.cardsVisible = [];
    this.cardsClickable = [];
    this.solutionIdx = [];
  }

  generateRandomExercise() {
    this.initAllValues();

    this.tableSize = this.getSizeOfTable();

    this.constructTableCards();
  }

  getSizeOfTable() {
    if (this.level === 1) {
      return 3; // 3x3 Table
    } else if (this.level === 2) {
      return 4;
    } else {
      return 5;
    }
  }

  constructTableCards() {
    for (let i = 0; i < this.tableSize; i++) {
      this.cardsId[i] = [];
      for (let j = 0; j < this.tableSize; j++) {
        const randomId = Math.floor((Math.random() * 127));
        this.cardsId[i][j] =  randomId;
      }
    }

    // First row: all cards are not visible. This row used by the helper
    this.cardsVisible[0] = [];
    this.cardsClickable[0] = [];
    for (let j = 0; j < this.tableSize; j++) {
      this.cardsVisible[0][j] =  false;
      this.cardsClickable[0][j] = true;
    }

    let openCardCounter = 0;
    for (let i = 1; i < this.tableSize; i++) {
      this.cardsVisible[i] = [];
      this.cardsClickable[i] = [];
      for (let j = 0; j < this.tableSize - 1; j++) {
        const rand = Math.floor((Math.random() * 2));
        if (rand === 0) {
          this.cardsVisible[i][j] = false;
        } else {
          this.cardsVisible[i][j] = true;
          openCardCounter ++;
        }
        this.cardsClickable[i][j] = false;
      }
      this.cardsVisible[i][this.tableSize - 1] = false;
      this.cardsClickable[i][this.tableSize - 1] = true;
    }

    // At least one card Open
    if (openCardCounter < 1) {
      const randRow = Math.floor((Math.random() * (this.tableSize - 1)) + 1);
      const randColumn = Math.floor((Math.random() * (this.tableSize - 1)));
      this.cardsVisible[randRow][randColumn] = true;
    }

    this.cardsVisibleHelper.emit(this.cardsVisible);
  }

  turnCard(row: number, column: number) {
    if (this.cardsClickable[row][column]) {
      if (this.isReadyForClairvoyant && this.solutionIdx.length === 0) {
        this.cardsVisible[row][column] = !(this.cardsVisible[row][column]);
        this.solutionIdx = [row, column];
        console.log(this.solutionIdx);
        this.closedCardIdx.emit(this.solutionIdx);
      } else if (this.isReadyForClairvoyant) {
        this.clickedCardIdx.emit([row, column]);
        if (row === this.solutionIdx[0] && column === this.solutionIdx[1]) {
          this.cardsVisible[row][column] = !(this.cardsVisible[row][column]);
        }
      } else {
        this.cardsVisible[row][column] = !(this.cardsVisible[row][column]);
        this.cardsVisibleHelper.emit(this.cardsVisible);
      }
    }
  }

  getAllCardsClickable() {
    for (let i = 0; i < this.tableSize; i++) {
      for (let j = 0; j < this.tableSize; j++) {
        this.cardsClickable[i][j] = true;
      }
    }
  }

  getImageSrc(row: number, column: number) {
    if (this.cardsVisible[row][column]) {
      return this.cards[this.cardsId[row][column]].imageSrc;
    } else {
      // TODO insert a cover!!
      return './assets/images/kartentricks/card_cover.png';
    }
  }

  isCover(i: number, j: number) {
    if (this.cardsVisible[i][j]) {
      return false;
    } else {
      return true;
    }
  }


  getMaxSize() {
    if (this.level === 1) {
      return '9%';
    } else if (this.level === 2) {
      return '7%';
    } else {
      return '6%';
    }
  }
}
